import salesSuppliersMSTListPage from './salesSuppliersMSTListPage';

export default salesSuppliersMSTListPage;
